/**
 * Filter Carousel - Drag to scroll functionality for non-touch devices
 * Enables mouse drag scrolling on the filter carousel
 */

(function() {
  'use strict';

  function initFilterCarousel() {
    const carousels = document.querySelectorAll('.filter-carousel');

    carousels.forEach(carousel => {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let hasMoved = false;

      // Prevent default drag on all child elements
      carousel.querySelectorAll('*').forEach(el => {
        el.setAttribute('draggable', 'false');
      });

      carousel.addEventListener('mousedown', (e) => {
        isDown = true;
        hasMoved = false;
        startX = e.pageX - carousel.offsetLeft;
        scrollLeft = carousel.scrollLeft;
      });

      carousel.addEventListener('mouseleave', () => {
        if (isDown) {
          isDown = false;
          carousel.classList.remove('filter-carousel--grabbing');
        }
      });

      carousel.addEventListener('mouseup', (e) => {
        const wasGrabbing = isDown && hasMoved;
        isDown = false;
        carousel.classList.remove('filter-carousel--grabbing');

        // If we were dragging, prevent the click
        if (wasGrabbing) {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      carousel.addEventListener('mousemove', (e) => {
        if (!isDown) return;

        const x = e.pageX - carousel.offsetLeft;
        const walk = x - startX;

        // Only start dragging after moving a few pixels
        if (Math.abs(walk) > 5) {
          hasMoved = true;
          carousel.classList.add('filter-carousel--grabbing');
          e.preventDefault();
        }

        if (hasMoved) {
          carousel.scrollLeft = scrollLeft - walk;
        }
      });

      // Prevent click on labels when dragging
      carousel.addEventListener('click', (e) => {
        if (hasMoved) {
          e.preventDefault();
          e.stopPropagation();
          hasMoved = false;
        }
      }, true);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterCarousel);
  } else {
    initFilterCarousel();
  }

  // Re-initialize on Shopify section refresh
  document.addEventListener('shopify:section:load', initFilterCarousel);
})();
